module.exports = __webpack_public_path__ + "img/estimate-cost.png";